<template>

<div class="container-fluid">
  <div class="row">
    <div class="col-12">
      <h2 class="mb-4">{{__('lang.shoppingcart.cartdelete')}}</h2>
      <form class="needs-validation" method="post" novalidate="novalidate">
        <div class="form-row" v-show="project.configuration.id !== null">
          <div class="form-group col">
            <label class="col-form-label col-form-label-sm" for="description">{{__('lang.shoppingcart.save.description')}}</label>
            <input class="form-control-plaintext border-0 bg-transparent" name="description" id="description" disabled v-model="project.configuration.description"/>
          </div>
<!--          <div class="form-group col">
            <label class="col-form-label col-form-label-sm" for="editor">{{__('lang.shoppingcart.save.editor')}}</label>
            <input class="form-control form-control-plaintext border-0 bg-transparent" name="editor" id="editor" disabled v-model="project.configuration.editor"/>
          </div>-->
        </div>
        <p class="alert alert-danger">{{__('lang.shoppingcart.confirmcartdelete')}}</p>
        <div class="form-row my-4">
          <div class="form-group col-12 col-md-6 order-2 order-md-1">
            <button class="btn btn-gray-50 text-white btn-block" type="reset" data-dismiss="modal">
              <svg class="icon">
                <use xlink:href="/assets/img/icon-sprite.svg#global.form.reset" xmlns:xlink="http://www.w3.org/1999/xlink"></use>
              </svg>{{__('lang.btn.cancel')}}
            </button>
          </div>
          <div class="form-group col-12 col-md-6 order-1 order-md-2">
            <button class="btn btn-primary btn-block border-0" type="submit" @click.prevent="removeCart">
              <svg class="icon">
                <use xlink:href="/assets/img/icon-sprite.svg#global.form.send" xmlns:xlink="http://www.w3.org/1999/xlink"></use>
              </svg>{{__('lang.btn.confirm')}}
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
<!--
  <div class="container-fluid">
  <div class="row">
    <div class="col-12">
      <h2 class="mb-4">Warenkorb löschen</h2>
      <form class="needs-validation" method="post" novalidate="novalidate">
        <div class="form-row">
          <div class="form-group col">
            <label class="col-form-label col-form-label-sm" for="formfield_3">Bezeichnung</label>
            <input class="form-control form-control-plaintext border-0 bg-transparent" name="formfield_3" value="Rebholz - Wohnen am Park"/>
          </div>
          <div class="form-group col">
            <label class="col-form-label col-form-label-sm" for="formfield_2">Bearbeiter</label>
            <input class="form-control form-control-plaintext border-0 bg-transparent" name="formfield_2" value="Max Mustermann"/>
          </div>
        </div>
        <p class="alert alert-danger">M&ouml;chten Sie diesen Warenkorb wirklich l&ouml;schen?</p>
        <div class="form-row my-4">
          <div class="form-group col-12 col-md-6 order-2 order-md-1">
            <button class="btn btn-gray-50 text-white btn-block" type="reset" data-dismiss="modal">
              <svg class="icon">
                <use xlink:href="/assets/img/icon-sprite.svg#global.form.reset" xmlns:xlink="http://www.w3.org/1999/xlink"></use>
              </svg>Abbrechen
            </button>
          </div>
          <div class="form-group col-12 col-md-6 order-1 order-md-2">
            <button class="btn btn-primary btn-block border-0" type="submit">
              <svg class="icon">
                <use xlink:href="/assets/img/icon-sprite.svg#global.form.send" xmlns:xlink="http://www.w3.org/1999/xlink"></use>
              </svg>Bestätigen
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
 -->




</template>

<script>

    export default {
        computed: {
          project: {
              get () {
                return this.$store.state.projectData.project
              },
              set (value) {
                    this.$store.commit('projectData/updateProject', value)
                }
          },

        },
        data() {
          return {

          }
		    },
        methods: {
          removeCart:function(){
            this.$store.commit('shoppingcart/removeCart', this.shoppingcart_item)
            document.getElementById('closeModalCartDelete').click();
          },

        },
        mounted () {
        },
        created() {

        },
       /*
        watch: {
          selectedcategories:{
            handler: function(){
              this.storeCategories();
            },
            deep:true //You need to set deep to true when watching an array or object so that Vue knows that it should watch the nested data for changes.
          }
        }
        */






    }


</script>
